export var ImageOrientation;
(function (ImageOrientation) {
    ImageOrientation["Up"] = "UP";
    ImageOrientation["Down"] = "DOWN";
    ImageOrientation["Left"] = "LEFT";
    ImageOrientation["Right"] = "RIGHT";
})(ImageOrientation || (ImageOrientation = {}));
//# sourceMappingURL=definitions.js.map